import React from 'react';
import { Box } from '@mui/material';
import ComingSoon from '../../Components/ComingSoon';

const Resources: React.FC = () => {
  return (
    <Box>
      <ComingSoon
        title="Resources"
        subtitle="Annual Reports Resources & Documentation"
        description="Access helpful resources, guides, and documentation to assist you through the annual reporting process."
      />
    </Box>
  );
};

export default Resources;
